import { doc, getDoc, serverTimestamp, setDoc, Timestamp } from 'firebase/firestore';
import { getFirebaseClients } from '../firebase';
import { siteContentSchema, type SiteContent } from '../schemas/siteContent';

/**
 * Site content is stored as a single document at `siteContent/main`. Editing
 * always overwrites the whole doc (sections are tightly coupled, no partial
 * patch is meaningful).
 */
const COLLECTION = 'siteContent';
const DOC_ID = 'main';

function db() {
  return getFirebaseClients().firestore;
}

export async function getSiteContent(): Promise<SiteContent | null> {
  const snap = await getDoc(doc(db(), COLLECTION, DOC_ID));
  if (!snap.exists()) return null;
  const raw = snap.data() as Record<string, unknown>;
  const updatedAt =
    raw.updatedAt instanceof Timestamp
      ? raw.updatedAt.toDate().toISOString()
      : (raw.updatedAt as string | undefined) ?? new Date().toISOString();
  return siteContentSchema.parse({ ...raw, updatedAt });
}

export async function saveSiteContent(input: Omit<SiteContent, 'updatedAt'>): Promise<void> {
  // Validate everything except updatedAt (we set it server-side).
  await setDoc(doc(db(), COLLECTION, DOC_ID), {
    ...input,
    updatedAt: serverTimestamp(),
  });
}
